
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetServerSideProps } from "next";
import type { HeaderLinks } from "@broadside/common";
import type { AppProps } from "../../util";
import type { YachtSearchPageProps } from "../../client/page/pages/YachtSearchPage";
import { asLanguage } from "@broadside/common";
import { YachtSearchPage } from "../../client/page/pages/YachtSearchPage";
import { BroadsideApi } from "../../server/broadside-api";
const getHeaderLinks = async (api: BroadsideApi): Promise<HeaderLinks | undefined> => {
    try {
        return await api.getHeaderLinks() ?? undefined;
    }
    catch {
        return undefined;
    }
};
const getServerSideProps: GetServerSideProps<AppProps & YachtSearchPageProps> = async ({ req, query, locale }) => {
    const api = new BroadsideApi({
        req,
        language: asLanguage(locale),
    });
    const [headerLinks, currencies] = await Promise.all([
        getHeaderLinks(api),
        api.getCurrencies(),
    ]);
    return {
        props: {
            headerLinks,
            search: new URLSearchParams(query as Record<string, string>).toString(),
            currencies: currencies.data,
        },
    };
};
export default YachtSearchPage;

    async function __Next_Translate__getServerSideProps__197a1ed6eb9__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/search/yachts',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__197a1ed6eb9__ as getServerSideProps }
  